import React, { useEffect } from "react";
import { Button, message } from "antd";
import { AlreadyPaySearchBox } from "./SearchBox";
import { AlreadyPayDataTable } from "./DataTable";
import { YhBox } from "../../../../../components/YhBox";
import { useAlreadyCollectModel } from "./alreadyPayModel";
import { PayDetailDrawer } from "./CollectDetailDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const AlreadyCashPay = () => {
  const {
    dataSource,
    selectedRowKeys,
    setCollectDrawerVisible,
    loadData,
    setSelectedData,
  } = useAlreadyCollectModel();

  useEffect(() => {
    loadData({ pageNum: 1 }).then()
  }, [])

  useEffect(() => {
    let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    setSelectedData(selectedData)
  }, [selectedRowKeys]);

  const onOpenAccount = () => {
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      setCollectDrawerVisible(true);
    } else {
      message.error("请选择付款账单!");
    }
  }

  const action = (
    <div>
      {/* <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={() => { }}
        >
          导出
        </Button> */}
      <YhAuth resCode={ResourceAuthEnum.CASH_PAY_DONE_VW}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={onOpenAccount}
        >
          查看支付明细
        </Button>
      </YhAuth>
    </div>
  );

  return (
    <>
      <AlreadyPaySearchBox />
      <YhBox title={"已付列表"} action={action}>
        <AlreadyPayDataTable />
      </YhBox>
      <PayDetailDrawer />
    </>
  )
}

